<div class="d-md-none container">
	<button class="btn btn-primary d-md-none w-100 mb-3">Add</button>
</div>
<div class="text-end d-none d-md-block">
	<button ngbTooltip="Add" nstarButton class="btn rounded rounded-circle btn-primary">
		<i nstarIcon>add</i>
	</button>
</div>
